import { type FC, useMemo } from "react";
import FontAwesomeLight from "../../../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import { getFile, type MediaFilePages, type MediaSelectedType } from "../MediaUtilities";

interface Props {
    selected: Array<MediaSelectedType>;
    pages: MediaFilePages;
}

const DISPLAY_AMOUNT = 8;

interface MultiMediaSelectedType extends MediaSelectedType {
    hasConnections: boolean;
}

export const MultiDetails: FC<Props> = ({ selected, pages }) => {
    const remaining = selected.length - DISPLAY_AMOUNT;

    // Show items with connections at the top
    const items: Array<MultiMediaSelectedType> = useMemo(() => {
        const withConnections: Array<MultiMediaSelectedType> = [];
        const noConnections: Array<MultiMediaSelectedType> = [];

        for(const item of selected) {
            const file = getFile(item.index, pages);

            if(file) {
                if(file.connections.length) {
                    withConnections.push({
                        ...item,
                        hasConnections: true,
                    });
                    continue;
                }
            }

            noConnections.push({
                ...item,
                hasConnections: false,
            });
        }

        withConnections.sort((a, b) => {
            return a.name.localeCompare(b.name);
        });

        noConnections.sort((a, b) => {
            return a.name.localeCompare(b.name);
        });

        return [
            ...withConnections,
            ...noConnections,
        ];
    }, [ selected, pages ]);

    return (
        <div className="py-8">
            <ul className="w-full my-0 px-12">
                {items.slice(0, DISPLAY_AMOUNT).map(item => (
                    <li
                        key={item.id}
                        className="w-full"
                    >
                        <div className="whitespace-nowrap w-full text-ellipsis overflow-hidden">
                            {item.hasConnections && (
                                <span className="inline-block mr-1">
                                    <FontAwesomeLight icon="paperclip" />
                                </span>
                            )}
                            {item.name}
                        </div>
                    </li>
                ))}
            </ul>
            {remaining > 0 && (
                <div className="w-full text-center text-neutral-600 dark:text-neutral-400">
                    And {remaining} more files...
                </div>
            )}
        </div>
    );
};
